function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { BaseComponent, getUniqueDomId, getDateMeta, buildNavLinkAttrs, ContentContainer, getDayClassNames, formatDayString, createFormatter, EventContainer, getSegAnchorAttrs, isMultiDayRange, buildSegTimeText, DateComponent, memoize, ViewContainer, Scroller, NowTimer, sortEventSegs, getSegMeta, sliceEventStore, intersectRanges, startOfDay, addDays, injectStyles } from '@fullcalendar/core/internal.js';
import { createElement, Fragment } from '@fullcalendar/core/preact.js';

var ListViewHeaderRow = /*#__PURE__*/function (_BaseComponent) {
  _inherits(ListViewHeaderRow, _BaseComponent);

  var _super = _createSuper(ListViewHeaderRow);

  function ListViewHeaderRow() {
    var _this;

    _classCallCheck(this, ListViewHeaderRow);

    _this = _super.apply(this, arguments);
    _this.state = {
      textId: getUniqueDomId()
    };
    return _this;
  }

  _createClass(ListViewHeaderRow, [{
    key: "render",
    value: function render() {
      var _this$context = this.context,
          theme = _this$context.theme,
          dateEnv = _this$context.dateEnv,
          options = _this$context.options,
          viewApi = _this$context.viewApi;
      var _this$props = this.props,
          cellId = _this$props.cellId,
          dayDate = _this$props.dayDate,
          todayRange = _this$props.todayRange;
      var textId = this.state.textId;
      var dayMeta = getDateMeta(dayDate, todayRange); // will ever be falsy?

      var text = options.listDayFormat ? dateEnv.format(dayDate, options.listDayFormat) : ''; // will ever be falsy? also, BAD NAME "alt"

      var sideText = options.listDaySideFormat ? dateEnv.format(dayDate, options.listDaySideFormat) : '';
      var renderProps = Object.assign({
        date: dateEnv.toDate(dayDate),
        view: viewApi,
        textId: textId,
        text: text,
        sideText: sideText,
        navLinkAttrs: buildNavLinkAttrs(this.context, dayDate),
        sideNavLinkAttrs: buildNavLinkAttrs(this.context, dayDate, 'day', false)
      }, dayMeta); // TODO: make a reusable HOC for dayHeader (used in daygrid/timegrid too)

      return createElement(ContentContainer, {
        elTag: "tr",
        elClasses: ['fc-list-day'].concat(_toConsumableArray(getDayClassNames(dayMeta, theme))),
        elAttrs: {
          'data-date': formatDayString(dayDate)
        },
        renderProps: renderProps,
        generatorName: "dayHeaderContent",
        customGenerator: options.dayHeaderContent,
        defaultGenerator: renderInnerContent,
        classNameGenerator: options.dayHeaderClassNames,
        didMount: options.dayHeaderDidMount,
        willUnmount: options.dayHeaderWillUnmount
      }, function (InnerContent) {
        return (// TODO: force-hide top border based on :first-child
          createElement("th", {
            scope: "colgroup",
            colSpan: 3,
            id: cellId,
            "aria-labelledby": textId
          }, createElement(InnerContent, {
            elTag: "div",
            elClasses: ['fc-list-day-cushion', theme.getClass('tableCellShaded')]
          }))
        );
      });
    }
  }]);

  return ListViewHeaderRow;
}(BaseComponent);

function renderInnerContent(props) {
  return createElement(Fragment, null, props.text && createElement("a", Object.assign({
    id: props.textId,
    className: "fc-list-day-text"
  }, props.navLinkAttrs), props.text), props.sideText &&
  /* not keyboard tabbable */
  createElement("a", Object.assign({
    "aria-hidden": true,
    className: "fc-list-day-side-text"
  }, props.sideNavLinkAttrs), props.sideText));
}

var DEFAULT_TIME_FORMAT = createFormatter({
  hour: 'numeric',
  minute: '2-digit',
  meridiem: 'short'
});

var ListViewEventRow = /*#__PURE__*/function (_BaseComponent2) {
  _inherits(ListViewEventRow, _BaseComponent2);

  var _super2 = _createSuper(ListViewEventRow);

  function ListViewEventRow() {
    _classCallCheck(this, ListViewEventRow);

    return _super2.apply(this, arguments);
  }

  _createClass(ListViewEventRow, [{
    key: "render",
    value: function render() {
      var props = this.props,
          context = this.context;
      var options = context.options;
      var seg = props.seg,
          timeHeaderId = props.timeHeaderId,
          eventHeaderId = props.eventHeaderId,
          dateHeaderId = props.dateHeaderId;
      var timeFormat = options.eventTimeFormat || DEFAULT_TIME_FORMAT;
      return createElement(EventContainer, Object.assign({}, props, {
        elTag: "tr",
        elClasses: ['fc-list-event', seg.eventRange.def.url && 'fc-event-forced-url'],
        defaultGenerator: function defaultGenerator() {
          return renderEventInnerContent(seg, context);
        }
        /* weird */
        ,
        seg: seg,
        timeText: "",
        disableDragging: true,
        disableResizing: true
      }), function (InnerContent, eventContentArg) {
        return createElement(Fragment, null, buildTimeContent(seg, timeFormat, context, timeHeaderId, dateHeaderId), createElement("td", {
          "aria-hidden": true,
          className: "fc-list-event-graphic"
        }, createElement("span", {
          className: "fc-list-event-dot",
          style: {
            borderColor: eventContentArg.borderColor || eventContentArg.backgroundColor
          }
        })), createElement(InnerContent, {
          elTag: "td",
          elClasses: ['fc-list-event-title'],
          elAttrs: {
            headers: "".concat(eventHeaderId, " ").concat(dateHeaderId)
          }
        }));
      });
    }
  }]);

  return ListViewEventRow;
}(BaseComponent);

function renderEventInnerContent(seg, context) {
  var interactiveAttrs = getSegAnchorAttrs(seg, context);
  return createElement("a", Object.assign({}, interactiveAttrs), seg.eventRange.def.title);
}

function buildTimeContent(seg, timeFormat, context, timeHeaderId, dateHeaderId) {
  var options = context.options;

  if (options.displayEventTime !== false) {
    var eventDef = seg.eventRange.def;
    var eventInstance = seg.eventRange.instance;
    var doAllDay = false;
    var timeText;

    if (eventDef.allDay) {
      doAllDay = true;
    } else if (isMultiDayRange(seg.eventRange.range)) {
      // TODO: use (!isStart || !isEnd) instead?
      if (seg.isStart) {
        timeText = buildSegTimeText(seg, timeFormat, context, null, null, eventInstance.range.start, seg.end);
      } else if (seg.isEnd) {
        timeText = buildSegTimeText(seg, timeFormat, context, null, null, seg.start, eventInstance.range.end);
      } else {
        doAllDay = true;
      }
    } else {
      timeText = buildSegTimeText(seg, timeFormat, context);
    }

    if (doAllDay) {
      var renderProps = {
        text: context.options.allDayText,
        view: context.viewApi
      };
      return createElement(ContentContainer, {
        elTag: "td",
        elClasses: ['fc-list-event-time'],
        elAttrs: {
          headers: "".concat(timeHeaderId, " ").concat(dateHeaderId)
        },
        renderProps: renderProps,
        generatorName: "allDayContent",
        customGenerator: options.allDayContent,
        defaultGenerator: renderAllDayInner,
        classNameGenerator: options.allDayClassNames,
        didMount: options.allDayDidMount,
        willUnmount: options.allDayWillUnmount
      });
    }

    return createElement("td", {
      className: "fc-list-event-time"
    }, timeText);
  }

  return null;
}

function renderAllDayInner(renderProps) {
  return renderProps.text;
}
/*
Responsible for the scroller, and forwarding event-related actions into the "grid".
*/


var ListView = /*#__PURE__*/function (_DateComponent) {
  _inherits(ListView, _DateComponent);

  var _super3 = _createSuper(ListView);

  function ListView() {
    var _this2;

    _classCallCheck(this, ListView);

    _this2 = _super3.apply(this, arguments);
    _this2.computeDateVars = memoize(computeDateVars);
    _this2.eventStoreToSegs = memoize(_this2._eventStoreToSegs);
    _this2.state = {
      timeHeaderId: getUniqueDomId(),
      eventHeaderId: getUniqueDomId(),
      dateHeaderIdRoot: getUniqueDomId()
    };

    _this2.setRootEl = function (rootEl) {
      if (rootEl) {
        _this2.context.registerInteractiveComponent(_assertThisInitialized(_this2), {
          el: rootEl
        });
      } else {
        _this2.context.unregisterInteractiveComponent(_assertThisInitialized(_this2));
      }
    };

    return _this2;
  }

  _createClass(ListView, [{
    key: "render",
    value: function render() {
      var props = this.props,
          context = this.context;

      var _this$computeDateVars = this.computeDateVars(props.dateProfile),
          dayDates = _this$computeDateVars.dayDates,
          dayRanges = _this$computeDateVars.dayRanges;

      var eventSegs = this.eventStoreToSegs(props.eventStore, props.eventUiBases, dayRanges);
      return createElement(ViewContainer, {
        elRef: this.setRootEl,
        elClasses: ['fc-list', context.theme.getClass('table'), context.options.stickyHeaderDates !== false ? 'fc-list-sticky' : ''],
        viewSpec: context.viewSpec
      }, createElement(Scroller, {
        liquid: !props.isHeightAuto,
        overflowX: props.isHeightAuto ? 'visible' : 'hidden',
        overflowY: props.isHeightAuto ? 'visible' : 'auto'
      }, eventSegs.length > 0 ? this.renderSegList(eventSegs, dayDates) : this.renderEmptyMessage()));
    }
  }, {
    key: "renderEmptyMessage",
    value: function renderEmptyMessage() {
      var _this$context2 = this.context,
          options = _this$context2.options,
          viewApi = _this$context2.viewApi;
      var renderProps = {
        text: options.noEventsText,
        view: viewApi
      };
      return createElement(ContentContainer, {
        elTag: "div",
        elClasses: ['fc-list-empty'],
        renderProps: renderProps,
        generatorName: "noEventsContent",
        customGenerator: options.noEventsContent,
        defaultGenerator: renderNoEventsInner,
        classNameGenerator: options.noEventsClassNames,
        didMount: options.noEventsDidMount,
        willUnmount: options.noEventsWillUnmount
      }, function (InnerContent) {
        return createElement(InnerContent, {
          elTag: "div",
          elClasses: ['fc-list-empty-cushion']
        });
      });
    }
  }, {
    key: "renderSegList",
    value: function renderSegList(allSegs, dayDates) {
      var _this$context3 = this.context,
          theme = _this$context3.theme,
          options = _this$context3.options;
      var _this$state = this.state,
          timeHeaderId = _this$state.timeHeaderId,
          eventHeaderId = _this$state.eventHeaderId,
          dateHeaderIdRoot = _this$state.dateHeaderIdRoot;
      var segsByDay = groupSegsByDay(allSegs); // sparse array

      return createElement(NowTimer, {
        unit: "day"
      }, function (nowDate, todayRange) {
        var innerNodes = [];

        for (var dayIndex = 0; dayIndex < segsByDay.length; dayIndex += 1) {
          var daySegs = segsByDay[dayIndex];

          if (daySegs) {
            // sparse array, so might be undefined
            var dayStr = formatDayString(dayDates[dayIndex]);
            var dateHeaderId = dateHeaderIdRoot + '-' + dayStr; // append a day header

            innerNodes.push(createElement(ListViewHeaderRow, {
              key: dayStr,
              cellId: dateHeaderId,
              dayDate: dayDates[dayIndex],
              todayRange: todayRange
            }));
            daySegs = sortEventSegs(daySegs, options.eventOrder);

            var _iterator = _createForOfIteratorHelper(daySegs),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var seg = _step.value;
                innerNodes.push(createElement(ListViewEventRow, Object.assign({
                  key: dayStr + ':' + seg.eventRange.instance.instanceId
                  /* are multiple segs for an instanceId */
                  ,
                  seg: seg,
                  isDragging: false,
                  isResizing: false,
                  isDateSelecting: false,
                  isSelected: false,
                  timeHeaderId: timeHeaderId,
                  eventHeaderId: eventHeaderId,
                  dateHeaderId: dateHeaderId
                }, getSegMeta(seg, todayRange, nowDate))));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }

        return createElement("table", {
          className: 'fc-list-table ' + theme.getClass('table')
        }, createElement("thead", null, createElement("tr", null, createElement("th", {
          scope: "col",
          id: timeHeaderId
        }, options.timeHint), createElement("th", {
          scope: "col",
          "aria-hidden": true
        }), createElement("th", {
          scope: "col",
          id: eventHeaderId
        }, options.eventHint))), createElement("tbody", null, innerNodes));
      });
    }
  }, {
    key: "_eventStoreToSegs",
    value: function _eventStoreToSegs(eventStore, eventUiBases, dayRanges) {
      return this.eventRangesToSegs(sliceEventStore(eventStore, eventUiBases, this.props.dateProfile.activeRange, this.context.options.nextDayThreshold).fg, dayRanges);
    }
  }, {
    key: "eventRangesToSegs",
    value: function eventRangesToSegs(eventRanges, dayRanges) {
      var segs = [];

      var _iterator2 = _createForOfIteratorHelper(eventRanges),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var eventRange = _step2.value;
          segs.push.apply(segs, _toConsumableArray(this.eventRangeToSegs(eventRange, dayRanges)));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return segs;
    }
  }, {
    key: "eventRangeToSegs",
    value: function eventRangeToSegs(eventRange, dayRanges) {
      var dateEnv = this.context.dateEnv;
      var nextDayThreshold = this.context.options.nextDayThreshold;
      var range = eventRange.range;
      var allDay = eventRange.def.allDay;
      var dayIndex;
      var segRange;
      var seg;
      var segs = [];

      for (dayIndex = 0; dayIndex < dayRanges.length; dayIndex += 1) {
        segRange = intersectRanges(range, dayRanges[dayIndex]);

        if (segRange) {
          seg = {
            component: this,
            eventRange: eventRange,
            start: segRange.start,
            end: segRange.end,
            isStart: eventRange.isStart && segRange.start.valueOf() === range.start.valueOf(),
            isEnd: eventRange.isEnd && segRange.end.valueOf() === range.end.valueOf(),
            dayIndex: dayIndex
          };
          segs.push(seg); // detect when range won't go fully into the next day,
          // and mutate the latest seg to the be the end.

          if (!seg.isEnd && !allDay && dayIndex + 1 < dayRanges.length && range.end < dateEnv.add(dayRanges[dayIndex + 1].start, nextDayThreshold)) {
            seg.end = range.end;
            seg.isEnd = true;
            break;
          }
        }
      }

      return segs;
    }
  }]);

  return ListView;
}(DateComponent);

function renderNoEventsInner(renderProps) {
  return renderProps.text;
}

function computeDateVars(dateProfile) {
  var dayStart = startOfDay(dateProfile.renderRange.start);
  var viewEnd = dateProfile.renderRange.end;
  var dayDates = [];
  var dayRanges = [];

  while (dayStart < viewEnd) {
    dayDates.push(dayStart);
    dayRanges.push({
      start: dayStart,
      end: addDays(dayStart, 1)
    });
    dayStart = addDays(dayStart, 1);
  }

  return {
    dayDates: dayDates,
    dayRanges: dayRanges
  };
} // Returns a sparse array of arrays, segs grouped by their dayIndex


function groupSegsByDay(segs) {
  var segsByDay = []; // sparse array

  var i;
  var seg;

  for (i = 0; i < segs.length; i += 1) {
    seg = segs[i];
    (segsByDay[seg.dayIndex] || (segsByDay[seg.dayIndex] = [])).push(seg);
  }

  return segsByDay;
}

var css_248z = ":root{--fc-list-event-dot-width:10px;--fc-list-event-hover-bg-color:#f5f5f5}.fc-theme-standard .fc-list{border:1px solid var(--fc-border-color)}.fc .fc-list-empty{align-items:center;background-color:var(--fc-neutral-bg-color);display:flex;height:100%;justify-content:center}.fc .fc-list-empty-cushion{margin:5em 0}.fc .fc-list-table{border-style:hidden;width:100%}.fc .fc-list-table tr>*{border-left:0;border-right:0}.fc .fc-list-sticky .fc-list-day>*{background:var(--fc-page-bg-color);position:sticky;top:0}.fc .fc-list-table thead{left:-10000px;position:absolute}.fc .fc-list-table tbody>tr:first-child th{border-top:0}.fc .fc-list-table th{padding:0}.fc .fc-list-day-cushion,.fc .fc-list-table td{padding:8px 14px}.fc .fc-list-day-cushion:after{clear:both;content:\"\";display:table}.fc-theme-standard .fc-list-day-cushion{background-color:var(--fc-neutral-bg-color)}.fc-direction-ltr .fc-list-day-text,.fc-direction-rtl .fc-list-day-side-text{float:left}.fc-direction-ltr .fc-list-day-side-text,.fc-direction-rtl .fc-list-day-text{float:right}.fc-direction-ltr .fc-list-table .fc-list-event-graphic{padding-right:0}.fc-direction-rtl .fc-list-table .fc-list-event-graphic{padding-left:0}.fc .fc-list-event.fc-event-forced-url{cursor:pointer}.fc .fc-list-event:hover td{background-color:var(--fc-list-event-hover-bg-color)}.fc .fc-list-event-graphic,.fc .fc-list-event-time{white-space:nowrap;width:1px}.fc .fc-list-event-dot{border:calc(var(--fc-list-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-list-event-dot-width)/2);box-sizing:content-box;display:inline-block;height:0;width:0}.fc .fc-list-event-title a{color:inherit;text-decoration:none}.fc .fc-list-event.fc-event-forced-url:hover a{text-decoration:underline}";
injectStyles(css_248z);
export { ListView };